import { Box } from '@mui/material';

import { About, Benefits, Ecosystem, Intro, UseCases } from './ui';

export const Home = () => {
  return (
    <Box>
      <Intro />
      <About />
      <UseCases />
      <Ecosystem />
      <Benefits />
    </Box>
  );
};
